import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      const isWebGL =
        this.state.error?.message?.includes('WebGL') ||
        this.state.error?.message?.includes('GL') ||
        this.state.error?.message?.includes('canvas');

      return (
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h1>앱 로딩 오류</h1>
          {isWebGL ? (
            <p>
              지도 렌더링에 필요한 WebGL을 사용할 수 없습니다.
              <br />
              브라우저의 하드웨어 가속을 활성화하거나, 다른 브라우저를 사용해 주세요.
            </p>
          ) : (
            <p>앱을 로드하는 중 오류가 발생했습니다.</p>
          )}
          <details style={{ marginTop: '1rem', textAlign: 'left', maxWidth: '600px', margin: '1rem auto' }}>
            <summary>오류 상세</summary>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '0.85rem' }}>
              {this.state.error?.message}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1.5rem',
              fontSize: '1rem',
              cursor: 'pointer',
              borderRadius: '4px',
              border: '1px solid #ccc',
              background: '#10b981',
              color: 'white',
            }}
          >
            새로고침
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
